<template>
  <div class="index-1-left-1">
    <div class="index-title">
      <span>{{ $t('propertyIndex.communityInfo') }}</span>
    </div>
    <div class="flex justify-between border-bottom index-1-left-1-content">
      <div v-for="(item, index) in stats" :key="index" class="flex justify-center" >
        <div class="index-1-left-img">
          <i :class="item.icon"></i>
        </div>
        <div>
          <div class="index-number">{{ indexCommunityViewInfo[item.key] }}</div>
          <div class="index-number-describe">{{ $t(`propertyIndex.${item.label}`) }}</div>
        </div>
      </div>
    </div>
    <div class="flex justify-between index-1-left-1-bottom">
      <div class="flex justify-between index-1-left-1-bottom-item">
        <div class="text-center">
          <div class="index-name">{{ $t('propertyIndex.residentReg') }}</div>
          <div class="index-name-ico">
            <i class="el-icon-user"></i>
          </div>
        </div>
        <div class="text-center">
          <div class="index-number">{{ indexCommunityViewInfo.ownerCount }}
            <span class="index-number-unit">{{ $t('propertyIndex.unit') }}</span>
          </div>
          <div class="index-number-describe margin-top-sm" @click="_toOwner">
            {{ $t('propertyIndex.registerResident') }} >
          </div>
        </div>
      </div>
      <div class="flex justify-between index-1-left-1-bottom-item">
        <div class="text-center">
          <div class="index-name">{{ $t('propertyIndex.vehicle') }}</div>
          <div class="index-name-ico">
            <i class="el-icon-truck"></i>
          </div>
        </div>
        <div class="text-center">
          <div class="index-number">{{ indexCommunityViewInfo.carCount }}
            <span class="index-number-unit">{{ $t('propertyIndex.unit') }}</span>
          </div>
          <div class="index-number-describe margin-top-sm" @click="_toCar">
            {{ $t('propertyIndex.viewVehicle') }} >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPropertyAssetsIndex } from '@/api/index/propertyIndexApi'

export default {
  name: 'IndexCommunity',
  data() {
    return {
      indexCommunityViewInfo: {
        floorCount: 0,
        roomCount: 0,
        shopCount: 0,
        ownerCount: 0,
        spaceCount: 0,
        carCount: 0,
      },
      stats: [
        { key: 'floorCount', label: 'building', icon: 'el-icon-office-building' },
        { key: 'roomCount', label: 'house', icon: 'el-icon-house' },
        { key: 'shopCount', label: 'shop', icon: 'el-icon-shopping-bag-2' },
        { key: 'spaceCount', label: 'parkingSpace', icon: 'el-icon-truck' }
      ]
    }
  },
  created() {
  },
  methods: {
    _loadPropertyIndexAssets() {
      const param = {
        page: 1,
        row: 10,
        communityId: this.getCommunityId()
      }

      getPropertyAssetsIndex(param)
        .then(res => {
          if (res.code === 0) {
            Object.assign(this.indexCommunityViewInfo, res.data)
          }
        })
        .catch(err => {
          console.error('请求失败处理', err)
        })
    },
    _toOwner() {
      this.$router.push('/pages/property/listOwner?tab=ownerInfo')
    },
    _toCar() {
      this.$router.push('/pages/property/listOwnerCar?tab=ownerCar')
    }
  }
}
</script>

<style lang="scss" scoped>
.index-1-left-1 {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  
  .index-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: left;
    color: #333;
  }
  
  .index-1-left-1-content {
    padding: 50px 0;
    border-bottom: 1px solid #eee;

    > div {
      width: 25%;
      min-width: 80px;
      max-width: 150px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .index-1-left-img {
      width: 40px;
      height: 40px;
      background: var(--ds-primary-sub);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 8px;

      i {
        font-size: 20px;
        color: var(--ds-primary);
      }
    }

    .index-number {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      word-break: break-all;
      line-height: 1.2;
    }

    .index-number-describe {
      font-size: 11px;
      color: #999;
      margin-top: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }
  
  .index-1-left-1-bottom {
    padding: 28px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .index-1-left-1-bottom-item {
      flex: 1;
      min-width: 0;
      border-radius: 4px;
      padding: 10px;

      .index-name {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        text-align: center;
      }

      .index-name-ico {
        width: 40px;
        height: 40px;
        background: var(--ds-primary-sub);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px auto;

        i {
          font-size: 20px;
          color: var(--ds-primary);
        }
      }

      .index-number {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        text-align: center;
        word-break: break-all;

        .index-number-unit {
          font-size: 12px;
          color: #999;
        }
      }

      .index-number-describe {
        font-size: 11px;
        color: var(--ds-primary);
        cursor: pointer;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  
  .margin-top-sm {
    margin-top: 5px;
  }
}
</style>